// extracted by mini-css-extract-plugin
export var body = "ConsultantCover-module--body--aba36";
export var container = "ConsultantCover-module--container--ba9e8";
export var heading = "ConsultantCover-module--heading--fe3a9";
export var inner = "ConsultantCover-module--inner--e69cc";
export var photo = "ConsultantCover-module--photo--fcf7b";
export var qualifications = "ConsultantCover-module--qualifications--b18e3";
export var specialities = "ConsultantCover-module--specialities--c3d8f";